import React from 'react'

const Merchandise = () => {
  return (
    <div>
      
    </div>
  )
}

export default Merchandise
